import { render, staticRenderFns } from "./TheStaffEmployee.vue?vue&type=template&id=6b438483&scoped=true&"
import script from "./TheStaffEmployee.vue?vue&type=script&lang=js&"
export * from "./TheStaffEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b438483",
  null
  
)

export default component.exports